export default "__VITE_ASSET__DZUcpSDv__"